// Single source of truth for the driver KV worker origin (see
// docs/adr/0001-embeds-on-dedicated-apex.md). NEXT_PUBLIC_WORKER_URL
// overrides the default everywhere this is imported — keep scripts/
// (plain Node, can't import this module) on the same env var + default.
export const DEFAULT_WORKER_URL = "https://odinkv.checkcitizenshipper.com"

export const WORKER_URL =
  process.env.NEXT_PUBLIC_WORKER_URL || DEFAULT_WORKER_URL
